export default "__VITE_ASSET__7fb8ddb0__"